import React, { useEffect, useState } from 'react'
import { Modal as AntDModal,DatePicker as AntdDatepicker,Button as AntButton } from 'antd'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import Select from "react-select";
import dayjs from 'dayjs';
import moment from 'moment';
export default function EmailSchedular({openSchedulePopup,setOpenSchedulePopup,emailContent,composeMailObj,handleSendEmail}) {
    const [isSchedule, setIsSchedule] = useState(false);
     const [timeZones, setTimeZones] = useState([]);
    const [errorShow, setErrorShow] = useState(false);
    const scheduleObject = {
        isSchedule : "",
        scheduleType : "", 
        timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone, 
        scheduleDate : dayjs().format("MM/DD/YYYY"),
        time : dayjs().add(1, 'hour').format('MM/DD/YYYY HH:mm:ss'),
      }
    const [scheduleObj, setScheduleObj] = useState({...scheduleObject});
    const [scheduleId, setScheduleId] = useState("1");
    const [showDatePicker, setShowDatePicker] = useState(false);

    useEffect(() => {  
        const tz = moment.tz.names();
        const tzWithOffsets = tz.map((timeZone) => {
          const offset = moment.tz(timeZone).utcOffset();
          const hours = Math.floor(Math.abs(offset) / 60);
          const minutes = Math.abs(offset) % 60;
          const sign = offset >= 0 ? '+' : '-';
          const formattedOffset = `UTC${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
          return { timeZone, formattedOffset };
        });
        let array = tzWithOffsets?.map((item,i)=>{
          return {value : item?.timeZone , label: item?.timeZone }
        })
        setTimeZones(array); 
      }, [])
      useEffect(()=>{
        if(openSchedulePopup){
          setIsSchedule(openSchedulePopup);
        }
      },[openSchedulePopup])
     let ScheduleArr = [
        {name: "1 hour", id: "1"},
        {name: "2 hours", id: "2"},
        {name: "4 hours", id: "3"},
        {name: "Tomorrow @ 10.00 AM", id: "4"},
        {name: "Custom date", id: "6"},
      ]
        useEffect(e=>{
          if(isSchedule){
            let obj = {...scheduleObj};
            obj.isSchedule = isSchedule;
            obj.scheduleType = scheduleId;
            setScheduleObj(obj);
          }
        }, [isSchedule, scheduleId])
     const onChangeTime = (name, e) => { 
        let time = e.currentTarget.value; 
        if (moment(scheduleObj.scheduleDate + " " + e.currentTarget.value + ":00").isSameOrBefore(moment(new Date()))) {
          setErrorShow(true);
        }else{
          setErrorShow(false)
        }
          setScheduleObj({...scheduleObj, time : time})
      };
    function disabledDateLocal(current) { 
        const today = moment().startOf('day'); 
        if (current && current.isBefore(today, 'day')) {
          return true;
        }
    }
        const getDatePickerValue = (date) => {
            try {
              let d = date
              if (d) {
                return dayjs(new Date(d));
              } else {
                return dayjs(new Date()).subtract(1,"day");
              }
            } catch (error) {}
          };
    const handleCloseScheduleModal= () =>{
        setOpenSchedulePopup(!openSchedulePopup); setIsSchedule(!isSchedule);
          setScheduleId("1");
          setScheduleObj({...scheduleObject})
      }
      const handleScheduleCancel= () =>{
        setIsSchedule(!isSchedule)
        setOpenSchedulePopup(!openSchedulePopup);
        setScheduleId("1");
        setScheduleObj({...scheduleObject})
      } 
      const handleSaveSchedule= () =>{
        if(!errorShow){
          let obj = {}
          obj.content = emailContent.toString("html");
          obj.fromAddress = composeMailObj?.from?.map((e) => e.email)?.join(",");
          obj.subject = composeMailObj?.subject;
          obj.toAddress = composeMailObj?.to?.map((e) => e.email)?.join(",");
          obj.ccAddress = composeMailObj?.cc?.map((e) => e.email)?.join(",");
          obj.bccAddress = composeMailObj?.bcc?.map((e) => e.email)?.join(",");
          obj.mailFormat = "html";
          obj.isSchedule = scheduleObj.isSchedule
          obj.scheduleType = scheduleObj.scheduleType 
          obj.timeZone = scheduleObj.timeZone == null ? "America/New_York" : scheduleObj.timeZone;
          obj.scheduleTime = scheduleObj.scheduleType=="6"?scheduleObj.scheduleDate + " " + scheduleObj.time + ":00":scheduleObj.time; 
          // obj.scheduleDate = dayjs(scheduleObj.scheduleDate).format("MM/DD/YYYY");  
          handleSendEmail(obj)
          setTimeout(() => {
            setIsSchedule(false);
          }, 200);
        }
      }
    
    const handleScheduleChange = (e) =>{
        let id = e.target.id;
        let obj = {};
        setScheduleId(id);
        if(id == "6"){
          obj.scheduleTime = scheduleObj.time 
          obj.scheduleDate = dayjs(obj.scheduleTime).format('MM/DD/YYYY')
        }else if(id == "1"){
          obj.scheduleTime = dayjs().add(1, 'hour').format('MM/DD/YYYY HH:mm:ss');
          obj.scheduleDate = dayjs(obj.scheduleTime).format('MM/DD/YYYY')
        }else if(id == "2"){
          obj.scheduleTime = dayjs().add(2, 'hour').format('MM/DD/YYYY HH:mm:ss');
          obj.scheduleDate = dayjs(obj.scheduleTime).format('MM/DD/YYYY')
        }else if(id == "3"){
          obj.scheduleTime = dayjs().add(4, 'hour').format('MM/DD/YYYY HH:mm:ss');
          obj.scheduleDate = dayjs(obj.scheduleTime).format('MM/DD/YYYY')
        }else if(id == "4"){
          obj.scheduleTime = (dayjs().add(1, 'day').hour(10).minute(0).second(0)).format('MM/DD/YYYY HH:mm:ss');
          obj.scheduleDate = dayjs(obj.scheduleTime).format('MM/DD/YYYY')
        } 
          setScheduleObj({...scheduleObj, 
            time : id=="6"?dayjs(obj.scheduleTime).format('HH:MM'):obj.scheduleTime,
            scheduleDate : obj.scheduleDate,
            timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone
          }) 
      } 
      
  return ( <AntDModal 
        title="Schedule" 
        className='Attachment-PopUp Schedule-PopUp'
        open={openSchedulePopup} 
        maskClosable={false}
        onCancel={e=>{handleCloseScheduleModal(e)}}
        footer={[
          <AntButton key="back" onClick={(e) => handleScheduleCancel()}>
            Cancel
          </AntButton>,
          <AntButton key="submit" type="primary" onClick={(e) => handleSaveSchedule()}>
            Schedule and send
          </AntButton>,
        ]}
        >
          {
            ScheduleArr && ScheduleArr.map((one, index)=>{
              return (
                <FormGroup className='schedule-input-wrapper schedule-formGroup' key={index}>
                  <Row>
                  <Col sm={1}></Col>
                    <Col sm={8}>
                    <div className="radioStyle">
                      <Input
                      style={{marginTop:".7rem"}}
                        type="radio"
                        name={"Schedule"}
                        id={one.id}
                        value={one.name}
                        checked={one.id == scheduleId}
                        onChange={(e) => {handleScheduleChange(e)}}
                      />
                    </div>
                      <Label
                        className="text-bold schedule-option"
                        for="preliminaryresearch"
                      >
                        {one.name}
                      </Label>
                    </Col>
                  </Row>
                </FormGroup>
              )
            })
          }
        {scheduleId == "6" && 
              <FormGroup className='schedule-date-wrapper schedule-formGroup'>
              <Row> 
                  <Col sm={6}>
                  <Label
                      className="text-bold schedule-option"
                      for="preliminaryresearch"
                    >
                    Select Date
                    </Label>
                    <AntdDatepicker
                      disabledDate={disabledDateLocal}
                      allowClear
                      portalId="root"
                      format="MM/DD/YYYY"
                      value={getDatePickerValue(scheduleObj.scheduleDate)}
                      placeholderText="Select a date"
                      popperClassName="ag-custom-component-popup"
                      className="form-control form-control-sm"
                      onChange={(date) => {
                        let editObj = { ...scheduleObj };
                        editObj["scheduleDate"] = dayjs(new Date(date)).format("MM/DD/YYYY");
                        setScheduleObj(editObj);
                      }}
                      open={showDatePicker}
                      onOpenChange={open => setShowDatePicker(open)}
                    />
                    
                  </Col>
                  <Col sm={6}>
                  <Label
                      className="text-bold schedule-option"
                      for="preliminaryresearch"
                    >
                    Select Time
                    </Label>
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      format="HH:mm a"
                      style={{fontWeight : "bold", color : "rgba(0, 0, 0, 0.85)"}}
                      onChange={(e) => {
                        onChangeTime("time", e);
                      }} 
                      value={scheduleObj ? scheduleObj.time : ""}
                    />
                    {
                      errorShow && <span style={{color : "red"}}>The Time cannot be in past!</span>
                    }
                  </Col>
              </Row>
              <Row> 
                  <Col sm={6}>
                  <Label
                      className="text-bold schedule-option"
                      for="preliminaryresearch"
                    >
                    Select Timezone
                    </Label>
                    <Select
                          options={timeZones}
                          closeMenuOnSelect={true}
                          onChange={(values) => setScheduleObj({...scheduleObj, timeZone : values.value})}
                          value={
                            scheduleObj
                              ? {label : scheduleObj.timeZone , value : scheduleObj.timeZone}
                              : null
                          }
                          menuPlacement="auto"
                        />
                    
                  </Col>
              </Row>
              </FormGroup>  } 
      </AntDModal> 
  )
}
